// extracted by css-extract-rspack-plugin
export default {"DataBucketList":"EU8MM","DataBucketListItemTitle":"_2F7I","DataBucketListItemDescription":"pJGpd","DataBucketListItemIcon":"sGbLd","DataBucketListItemContainer":"uZ7Da"};